import { DashboardLayout } from "../../dashboard/layout/DashboardLayout"

export const EstudianteGradosPage = () => {
  return (
    <DashboardLayout title="Grados">
      <div>GradosView</div>
    </DashboardLayout>
  )
}